import create, { SetState, StateCreator, StoreApi } from "zustand";
import { IDataItem } from "../pages/member-details/actionable-insights/alternative-generic-medication/alternative-generic-medication";


interface IGlobal_InformationStore {
  clearStore: () => void;
  currentSelectedIndex: number;
  setCurrentSelectedIndex: (x: number) => void;
  dataState: IDataItem[];
  setDataState: (x: IDataItem[]) => void;
}

let store: StateCreator<IGlobal_InformationStore, [], [], IGlobal_InformationStore> | StoreApi<IGlobal_InformationStore> = (set: SetState<IGlobal_InformationStore>) => ({
  currentSelectedIndex: -1,
  setCurrentSelectedIndex: (x) => {
    set(state => ({ currentSelectedIndex : x }))
  },

  dataState: [],
  setDataState: (x) => {
    set(state => ({ dataState : x }))
  },
  clearStore: () => {
    set(() => ({ currentSelectedIndex : -1 }));
    set(() => ({ dataState : [] }));
  },
});

export const useAlternativeGenericMedicationStore = create(store);
